import { useState } from 'react'
import { NavLink } from 'react-router-dom'
import Logo from '@assets/images/Logo.svg'
import styles from './Header.module.css'

const navLinks = [
  { path: '/', label: 'Home' },
  { path: '/who-we-are', label: 'Who We Are' },
  { path: '/our-services', label: 'Our Services' },
  { path: '/get-in-touch', label: 'Get in Touch' },
  { path: '/service-requests', label: 'Service Requests' },
]

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false)

  const toggleMenu = () => setMenuOpen((prev) => !prev)
  const closeMenu = () => setMenuOpen(false)

  return (
    <header className={styles.header}>
      <div className={styles.headerContainer}>
        <NavLink to="/" className={styles.logoLink} onClick={closeMenu}>
          <img src={Logo} alt="Nikket Engineering Works" className={styles.logo} />
        </NavLink>

        <nav className={styles.nav}>
          <ul className={styles.navList}>
            {navLinks.map((link) => (
              <li key={link.path} className={styles.navItem}>
                <NavLink
                  to={link.path}
                  className={({ isActive }) =>
                    `${styles.navLink} ${isActive ? styles.navLinkActive : ''}`
                  }
                  end={link.path === '/'}
                >
                  {link.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>

        <button
          className={`${styles.hamburger} ${menuOpen ? styles.hamburgerActive : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <span className={styles.hamburgerLine} />
          <span className={styles.hamburgerLine} />
          <span className={styles.hamburgerLine} />
        </button>
      </div>

      <div
        className={`${styles.mobileOverlay} ${menuOpen ? styles.mobileOverlayOpen : ''}`}
        onClick={closeMenu}
      />
      <div className={`${styles.mobileMenu} ${menuOpen ? styles.mobileMenuOpen : ''}`}>
        <ul className={styles.mobileNavList}>
          {navLinks.map((link) => (
            <li key={link.path}>
              <NavLink
                to={link.path}
                className={({ isActive }) =>
                  `${styles.mobileNavLink} ${isActive ? styles.navLinkActive : ''}`
                }
                end={link.path === '/'}
                onClick={() => {
                  closeMenu()
                  window.scrollTo(0, 0)
                }}
              >
                {link.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </header>
  )
}

export default Header
